import {createApp} from 'vue'
import App from './App.vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import router from './router'
import VueUeditorWrap from 'vue-ueditor-wrap';
import dayjs from "dayjs";

//引入Vue
const app = createApp(App);
//全局过滤器
app.config.globalProperties.$filters = {
  dateFormat(date, formatStr) {
    return dayjs(date).format(formatStr)
  }
};
//应用路由，注册组件，增加根容器
app.use(ElementPlus)//引入ElementPlus框架
   .use(router)//引入路由
   .use(VueUeditorWrap)//引入富文本编辑器
   .mount('#app');//启动vue

